<script setup>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import getNavigationIcon from '@services/GetNavaigationIcon';
import PartialHistory from './PartialHistory.vue';





const props = defineProps({
    showHistoryDropdown: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(['close', 'open']);

let openHistoryDropdown = ref(false);
let showPartialHistory = ref(false);
let partialHistoryType = ref('forward'); // 'forward' or 'previous'

const route = useRoute();

// Mock history data (replace with real data from your app)
const navigationHistory = ref({
    previousPages: [
        {
            id: 1,
            title: "Objective of the laboratory",
            type: "page",
            icon: "person",
        },
        {
            id: 2,
            title: "Tech requirements.pdf",
            type: "document",
            icon: "doc",
        },
        {
            id: 3,
            title: 'Search Results for "FMS"',
            type: "search",
            icon: "search",
        },
        { id: 4, title: "Robert Fox", type: "person", icon: "person" },
    ],
    forwardPages: [
        {
            id: 5,
            title: "Objective of the laboratory",
            type: "page",
            icon: "person",
        },
        {
            id: 6,
            title: "Tech requirements.pdf",
            type: "document",
            icon: "doc",
        },
        { id: 7, title: "Robert Fox", type: "person", icon: "person" },
        {
            id: 8,
            title: "Tech requirements.pdf",
            type: "document",
            icon: "doc",
        },
    ],
});

const navigateToHistoryItem = (item) => {
    console.log("Navigating to:", item);
        openHistoryDropdown.value = false;
    };

const getForwardHistory = () => {
    let history = localStorage.getItem(`forward-toggle-state`);
    let historyArray = history ? JSON.parse(history) : [];
    navigationHistory.value.forwardPages = historyArray.reverse();
}

const getPreviousHistory = () => {
    let history = localStorage.getItem(`back-toggle-state`);
    let historyArray = history ? JSON.parse(history) : [];
    navigationHistory.value.previousPages = historyArray.reverse();
}


const handleShowAll = (type) => {
    partialHistoryType.value = type;
    showPartialHistory.value = true;
    // Emit close event to parent to close the history dropdown
    emit('close');
};

const handlePartialHistoryClose = () => {
    showPartialHistory.value = false;
};

const handlePartialHistoryBack = () => {
    showPartialHistory.value = false;
    // Reopen the history dropdown
    emit('open');
};

watch(
    () => route.fullPath,
    () => {
        console.log('route changed – closing history dropdown');
        openHistoryDropdown.value = false;
        showPartialHistory.value = false;
    }
);

watch(() => props.showHistoryDropdown, (newVal) => {
    console.log("watch", newVal);
    if (newVal ) {
        showPartialHistory.value = false;
    }
    getForwardHistory();
    getPreviousHistory();
    openHistoryDropdown.value = newVal;
});

onMounted(() => {
  
    getForwardHistory();
    getPreviousHistory();
})
</script>

<template>
     <!-- History Dropdown Overlay (click outside to close) -->
     <div v-if="openHistoryDropdown" class="history-overlay" @click="emit('close')"></div>
     
     <!-- History Dropdown -->
     <div v-if="openHistoryDropdown" class="history-dropdown">
                    <div class="history-section">
                        <div class="history-header">
                            <span class="history-title">Forward Pages</span>
                            <span 
                                v-if="navigationHistory.forwardPages.length > 4" 
                                class="show-all" 
                                @click="handleShowAll('forward')"
                            >
                                Show all
                            </span>
                        </div>
                        <div class="history-items">
                            <div
                                v-for="item in navigationHistory.forwardPages.slice(0, 4)"
                                :key="item.id"
                                class="history-item"
                                @click="navigateToHistoryItem(item)"
                            >
                                <div class="history-icon">
                                    <img :src="getNavigationIcon.getIcon(item.icon)" alt="icon" width="24" height="24">
                                </div>
                                <router-link :to="item.url" class="history-link">
                                    <span class="history-title" :title="item.title">{{ item.title }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="history-section">
                        <div class="history-header">
                            <span class="history-title">Previous Pages</span>
                            <span 
                                v-if="navigationHistory.previousPages.length > 4" 
                                class="show-all" 
                                @click="handleShowAll('previous')"
                            >
                                Show all
                            </span>
                        </div>
                        <div class="history-items">
                            <div
                                v-for="item in navigationHistory.previousPages.slice(0, 4)"
                                :key="item.id"
                                class="history-item"
                                @click="navigateToHistoryItem(item)"
                            >
                                <div class="history-icon">
                                   <img :src="getNavigationIcon.getIcon(item.icon)" alt="icon" width="24" height="24">
                                </div>
                                <router-link :to="item.url" class="history-link">
                                    <span class="history-title" :title="item.title">{{ item.title }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>

                   
                </div>
    
    <!-- Partial History Component -->
    <PartialHistory 
        :showPartialHistory="showPartialHistory" 
        :historyType="partialHistoryType"
        @close="handlePartialHistoryClose"
        @back="handlePartialHistoryBack"
    />
</template>

<style scoped>
.history-item {
    display: flex;
    align-items: center;
    gap: 8px; /* equivalent to roughly 0.5rem or spacing-xs */
    padding: 4px 8px;
    cursor: pointer;
    border-radius: 6px;
}

.history-item:hover {
    background-color: var(--bg-secondary, #f3f4f6); /* Fallback color just in case */
}


.history-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    overflow: hidden;
    flex: 1;
    min-width: 0; /* Critical for truncating flex children */
}

.history-title {
   font-size: 12px;
   font-weight: 400;
   color:#101828;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
   width: 100%; /* explicit width to force filling container */
}
.show-all {
   font-size: 12px;
   font-weight: 400;
   color:#412CC9;
   cursor: pointer;
   user-select: none;
}

.show-all:hover {
   text-decoration: underline;
}

.history-overlay {
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   z-index: 99;
   background: transparent;
}
</style>